import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBeerMugEmpty, faHouse } from "@fortawesome/free-solid-svg-icons";

import { MainLayout } from "../layouts/mainLayout";

export const Error = () => {
  return (
    <MainLayout title="Page Not Found or Error">
      <Container className="py-5 text-center">
        <div className="kf-form-card mx-auto py-5 my-4" style={{ maxWidth: 580 }}>
          <div className="mb-3" style={{ fontSize: "3.5rem" }}>
            <FontAwesomeIcon icon={faBeerMugEmpty} />
          </div>
          <h1 className="h2 mb-2">Oops, we spilt our pint!</h1>
          <p className="text-secondary mb-4" style={{ maxWidth: 420, margin: "0 auto" }}>
            The page you were looking for doesn&apos;t seem to exist or an unexpected error occurred.
          </p>
          <Link to="/" className="btn btn-primary d-inline-flex align-items-center gap-2">
            <FontAwesomeIcon icon={faHouse} />
            <span>Return to Homepage</span>
          </Link>
        </div>
      </Container>
    </MainLayout>
  );
};